import { DateTime } from 'luxon'
import { datetime } from '../serialization'
import { BeWizrModel } from './BeWizrModel'

export class BeWizrLearningTrack extends BeWizrModel {

  public title!: string

  public itemCount: number = 0

  public capacity!:   number | null
  public placesLeft!: number | null

  public isEnrolled!:      boolean
  public isOnWaitingList!: boolean

  @datetime()
  public startDate!: DateTime | null

  @datetime()
  public endDate!: DateTime | null

  public shortDescription!: string | null
  public descriptionHtml!:  string | null

  public links!: {
    image:             string | null
    enroll:            string | null
    cancel:            string | null
    externalEnrollUrl: string | null
  }

  public items?: BeWizrLearningTrackItem[]

  protected afterDeserialize() {
    this.items = this.raw.items?.map(
      (it: any) => BeWizrLearningTrackItem.deserialize(it),
    )
  }

  public get mayEnroll() {
    return this.links.enroll != null || this.links.externalEnrollUrl != null
  }

  public get mayCancel() {
    return this.links.cancel != null
  }

}

export class BeWizrLearningTrackItem extends BeWizrModel {

  public title!: string
  public slug!:  string

  public type!: 'course' | 'meeting'

  @datetime()
  public startDate!: DateTime

  @datetime()
  public endDate!: DateTime

  public progress!: number | null

  public links!: {
    self:  string
    image: string | null
  }

  public isLocked?: boolean

  // Meetings

  public meetingId!: string

}